import { useEffect } from 'react';
import { getLoginUrl } from '../../auth/cognitoConfig';

export default function LoginPage() {
  useEffect(() => {
    window.location.href = getLoginUrl();
  }, []);

  return (
    <div className="mol-login">
      <div className="mol-login__card">
        <div className="mol-loading-spinner" />
        <p style={{ marginTop: '16px', color: '#6B7280' }}>Redirecting to sign in...</p>
      </div>
    </div>
  );
}
